import { getScopedItem, STORAGE_KEYS } from "../components/common/Helper";
import APIConstants from "./APIConstants";
import APIService from "./APIService";
import AzureAPIService, { setAzureAuthToken } from "./AzureAPIService";
import DebugService from "./DebugService";

/**
 * @description Billing Api Service
 */
const BillingApiService = {

  getTagList: async (selectedAccount, data) => {
    try {
      const dataRequest = {
        ...data,
        type: 'FILTERS'
      }

      if (getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)) {
        const userDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
        const parseToJson = JSON.parse(userDetails)

        if (selectedAccount) {
          dataRequest['userAccountId'] = selectedAccount
        }

        if (parseToJson['userId']) {
          dataRequest['userId'] = parseToJson['userId']
        }

        if (data['startMonthDate']) {
          dataRequest['startMonthDate'] = data['startMonthDate'].format('YYYY-MM-DD')
        }

        if (data['endMonthDate']) {
          dataRequest['endMonthDate'] = data['endMonthDate'].format('YYYY-MM-DD')
        }
      }

      delete dataRequest['filter']
      delete dataRequest['filterTagValues']

      return await APIService.post(APIConstants.ENDPOINT_RECOMMENDATION, dataRequest)
    } catch (err) {
      DebugService.error(`Billing Api Service: Error Caught while fetching tag list data`, err)
    }
  },

  getAzureTagList: async (selectedAccount, data) => {
    try {
      const dataRequest = {
        ...data,
        type: 'FILTERS'
      }

      if (getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)) {
        const userDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
        const parseToJson = JSON.parse(userDetails)

        if (selectedAccount) {
          dataRequest['userAccountId'] = selectedAccount
        }

        if (parseToJson['userId']) {
          dataRequest['userId'] = parseToJson['userId']
        }
      }

      if (getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAzureAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }

      delete dataRequest['filter']
      delete dataRequest['filterTagValues']
      delete dataRequest['dimension']
      delete dataRequest['startMonthDate']
      delete dataRequest['endMonthDate']

      return await AzureAPIService.post(APIConstants.ENDPOINT_AZURE_RECOMMENDATION, dataRequest)
    } catch (err) {
      DebugService.error(`Billing Api Service: Error Caught while fetching tag list data`, err)
    }
  },

  getCostExplorerData: async (data) => {
    try {
      let url = APIConstants.ENDPOINT_RECOMMENDATION

      if (getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)) {
        const userDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
        const parseToJson = JSON.parse(userDetails)

        if (parseToJson['userId']) {
          data['userId'] = parseToJson['userId']
        }

        // if (data['filter'] && data['filterTagValues']) {
        //   url += `&filter=${data['filter']['key']}`
        //   url += `&filterTagValues=${data['filterTagValues'].join(',')}`
        // }
      }

      return await APIService.post(url, data)
    } catch (err) {
      DebugService.error(`Billing Api Service: Error Caught while fetching cost explorer data`, err)
    }
  },

  getAzureCostExplorerData: async (data) => {
    try {
      let url = APIConstants.ENDPOINT_AZURE_RECOMMENDATION

      if (getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)) {
        const userDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
        const parseToJson = JSON.parse(userDetails)

        if (parseToJson['userId']) {
          data['userId'] = parseToJson['userId']
        }
      }

      if (getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAzureAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }

      return await AzureAPIService.post(url, data)
    } catch (err) {
      DebugService.error(`Billing Api Service: Error Caught while fetching cost explorer data`, err)
    }
  },

  getCloudCostConsoleData: async (data) => {
    try {
      data['type'] = 'CLOUD_COST_CONSOLE'
      data['userAccountId'] = data['selectedAccount']

      if (getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)) {
        const userDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
        const parseToJson = JSON.parse(userDetails)

        if (parseToJson['userId']) {
          data['userId'] = parseToJson['userId']
        }
      }
      delete data['selectedAccount']

      return await APIService.post(APIConstants.ENDPOINT_RECOMMENDATION, data)
    } catch (err) {
      DebugService.error(`Billing Api Service: Error Caught while fetching cloud cost console data`, err)
    }
  },

  getAzureCloudCostConsoleData: async (data) => {
    try {
      let url = `${APIConstants.ENDPOINT_AZURE_RECOMMENDATION}`

      if (getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)) {
        const userDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
        const parseToJson = JSON.parse(userDetails)

        if (parseToJson['userId']) {
          data['userId'] = parseToJson['userId']
        }
      }

      if (getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAzureAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }

      return await AzureAPIService.post(url, data)
    } catch (err) {
      DebugService.error(`Billing Api Service: Error Caught while fetching azure cloud cost console data`, err)
    }
  },

  getDataTransferData: async (data) => {
    try {
      data['type'] = 'DATA_TRANSFER_COST'
      data['userAccountId'] = data['selectedAccount']

      if (getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)) {
        const userDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
        const parseToJson = JSON.parse(userDetails)

        if (parseToJson['userId']) {
          data['userId'] = parseToJson['userId']
        }
      }

      delete data['selectedAccount']
      return await APIService.post(APIConstants.ENDPOINT_RECOMMENDATION, data)
    } catch (err) {
      DebugService.error(`Billing Api Service: Error Caught while fetching data transfer data`, err)
    }
  },

  getAzureDataTransferData: async (data) => {
    try {
      let url = APIConstants.ENDPOINT_AZURE_RECOMMENDATION

      if (getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)) {
        const userDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
        const parseToJson = JSON.parse(userDetails)

        if (parseToJson['userId']) {
          data['userId'] = parseToJson['userId']
        }
      }

      if (getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAzureAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }

      return await AzureAPIService.post(url, data)
    } catch (err) {
      DebugService.error(`Billing Api Service: Error Caught while fetching azure data transfer data`, err)
    }
  },

}

export default BillingApiService;
